module.exports = __webpack_public_path__ + "480efe4545780a7270e695f3a35677e7.mp3";